import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import ArticleSection from './components/ArticleSection';

const seoData = {
  title: '免费电影在线观看-高清全集无需注册 | 光影在线',
  description: '免费电影在线观看，海量高清影片资源随时畅享，无需下载、无需注册，支持手机电脑多端播放。涵盖最新院线大片、经典老片、国产剧、欧美影视等全品类，让你随时随地享受极致观影体验。',
  keywords: '免费电影在线观看,免费电影在线观看高清,免费电影在线观看完整版,最新电影免费在线观看,免费电影网站推荐,在线看电影不卡,高清电影免费播放',
  canonicalUrl: 'https://guangyingzx.com/',
  ogImage: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20with%20warm%20golden%20lighting%20and%20film%20projector%2C%20elegant%20dark%20red%20curtains%2C%20cinematic%20atmosphere&width=1200&height=630&seq=og-home&orientation=landscape',
  schemaJson: {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '光影在线',
        url: 'https://guangyingzx.com',
        description: '免费电影在线观看平台，提供海量高清影片资源',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-8888',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebSite',
        name: '光影在线',
        url: 'https://guangyingzx.com',
        potentialAction: {
          '@type': 'SearchAction',
          'target': 'https://guangyingzx.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '免费电影在线观看-高清全集无需注册',
        description: '免费电影在线观看，海量高清影片资源随时畅享，无需下载、无需注册，支持手机电脑多端播放。',
        url: 'https://guangyingzx.com/',
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead {...seoData} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedMovies />
        <CategorySection />
        <LatestUpdates />
        <ArticleSection />
      </main>
      <Footer />
    </>
  );
}